import React from 'react';
import './DashboardOverview.css';

function DashboardOverview({ apiBase, stats, onRefresh }) {
  return (
    <div className="dashboard-overview">
      <div className="overview-header">
        <h2>Dashboard Penerimaan Siswa</h2>
        <button className="btn-refresh" onClick={onRefresh} title="Refresh">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 4 23 10 17 10"></polyline>
            <polyline points="1 20 1 14 7 14"></polyline>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36M20.49 15a9 9 0 0 1-14.85 3.36"></path>
          </svg>
        </button>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#cffafe' }}>
            <svg viewBox="0 0 24 24" fill="currentColor" color="#0284c7">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
            </svg>
          </div>
          <div className="stat-content">
            <p className="stat-label">Total Pendaftar</p>
            <p className="stat-value">{stats.totalApplicants}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#dbeafe' }}>
            <svg viewBox="0 0 24 24" fill="currentColor" color="#0284c7">
              <path d="M9 11l3 3L22 4" />
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
            </svg>
          </div>
          <div className="stat-content">
            <p className="stat-label">Test Selesai</p>
            <p className="stat-value" style={{ color: '#0284c7' }}>{stats.testCompleted}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#fef3c7' }}>
            <svg viewBox="0 0 24 24" fill="currentColor" color="#f59e0b">
              <circle cx="12" cy="12" r="1" />
              <circle cx="19" cy="12" r="1" />
              <circle cx="5" cy="12" r="1" />
            </svg>
          </div>
          <div className="stat-content">
            <p className="stat-label">Test Pending</p>
            <p className="stat-value" style={{ color: '#f59e0b' }}>{stats.testPending}</p>
          </div>
        </div>
      </div>

      <div className="stats-section">
        <h3>Pendaftar Per Jenjang</h3>
        <div className="stats-cards-row">
          {Object.entries(stats.byLevel || {}).map(([level, count]) => (
            <div key={level} className="mini-stat">
              <p className="mini-label">{level}</p>
              <p className="mini-value">{count || 0}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="stats-section">
        <h3>Pendaftar Per Lokasi</h3>
        <div className="stats-cards-row">
          {Object.entries(stats.byLocation || {}).map(([location, count]) => (
            <div key={location} className="mini-stat">
              <p className="mini-label">{location}</p>
              <p className="mini-value">{count || 0}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="overview-actions">
        <h3>Quick Actions</h3>
        <div className="actions-grid">
          <button className="action-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Input Hasil Test
          </button>
          <button className="action-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            Lihat Semua Pendaftar
          </button>
          <button className="action-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 21H3V3h18v18zm-9-3h6v-6h-6v6zm0-8h6V5h-6v6zm-6 8h6v-6H6v6zm0-8h6V5H6v6z" />
            </svg>
            Export Report
          </button>
        </div>
      </div>
    </div>
  );
}

export default DashboardOverview;
